/* ==========================================================================
   Fiche produit — protège-cils Cilabri
   - galerie, choix du pack, ajout au panier (démo), carrousel des atouts, galeries des cartes pack
   - section avis : tri, filtre, « Voir plus », formulaire « Écrire un avis » (aucun avis au départ)
   - animations GSAP (fiche, section « Animations à reproduire ») :
       A1–A10  schéma de la tenue de la pose, à l'entrée à l'écran
       A14–A20 état de départ du schéma (au chargement)
       A11–A12 étapes de la frise atteintes (60 %), A21–A22 état de départ (au chargement)
       A13     remplissage du rail, lié au défilement (--cg-progress, scrub)
       A23     entrée de la réponse de FAQ (animation CSS cg-faq-in, styles.css)
       A24     pied de page « rideau » (animations.js)
   ========================================================================== */
(function () {
  "use strict";
  var doc = document;
  var CG = (window.CG = window.CG || {});
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function reduced() { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
  function money(n) { return n.toFixed(2).replace(".", ",") + " €"; }

  /* ---------- Galerie ---------- */
  function initGallery() {
    var main = $("#gallery-main");
    var thumbs = $$("[data-gallery-thumb]");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        main.src = btn.getAttribute("data-gallery-thumb");
        main.alt = btn.getAttribute("data-alt") || "";
        thumbs.forEach(function (b) { b.classList.toggle("is-active", b === btn); b.setAttribute("aria-pressed", String(b === btn)); });
      });
    });
  }

  /* ---------- Panier (démo : compteur d'en-tête) ---------- */
  function addToCart(name, price, statusEl) {
    // le compteur et le tiroir sont gérés par la couche boutique (shop.js)
    if (statusEl) {
      statusEl.hidden = false;
      statusEl.textContent = "Pack " + name + " (" + money(price) + ") ajouté au panier.";
    }
  }

  /* ---------- Bloc d'achat : choix du pack ---------- */
  function initBuy() {
    var form = $("[data-buy-form]");
    if (!form) return;
    var radios = $$("input[name=pack]", form);
    var total = $("[data-buy-total]", form);
    var note = $("[data-pack-note]", form);
    var status = $("[data-buy-status]", form);
    function current() { return radios.filter(function (r) { return r.checked; })[0] || radios[0]; }
    function update() {
      var r = current();
      total.textContent = money(parseFloat(String(r.getAttribute("data-price")).replace(",", ".")));
      note.textContent = r.getAttribute("data-note");
      if (status) status.hidden = true;
    }
    radios.forEach(function (r) { r.addEventListener("change", update); });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var r = current();
      addToCart(r.getAttribute("data-label"), parseFloat(String(r.getAttribute("data-price")).replace(",", ".")), status);
    });
    update();

    /* Cartes pack : ajout rapide + galeries */
    var cross = $("[data-cross-status]");
    $$("[data-quick-add]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var name = btn.getAttribute("data-name");
        var r = radios.filter(function (x) { return x.getAttribute("data-label") === name; })[0];
        if (!r) return;
        addToCart(name, parseFloat(String(r.getAttribute("data-price")).replace(",", ".")), cross);
      });
    });
    $$(".pc").forEach(function (card) {
      var track = $("[data-pc-track]", card);
      function go(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: reduced() ? "auto" : "smooth" }); }
      var prev = $("[data-pc-prev]", card), next = $("[data-pc-next]", card);
      if (prev) prev.addEventListener("click", function () { go(-1); });
      if (next) next.addEventListener("click", function () { go(1); });
    });
  }

  /* ---------- Carrousel des atouts ---------- */
  function initCarousel() {
    var root = $("[data-ingr]");
    if (!root) return;
    var track = $("[data-ingr-track]", root);
    var prev = $("[data-ingr-prev]", root), next = $("[data-ingr-next]", root);
    function step() {
      var card = $(".cg-pdp-ingr__card", track);
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.offsetWidth + gap : 300;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.setAttribute("aria-disabled", String(track.scrollLeft <= 1));
      next.setAttribute("aria-disabled", String(track.scrollLeft >= max));
    }
    function go(dir) { track.scrollBy({ left: dir * step(), behavior: reduced() ? "auto" : "smooth" }); }
    prev.addEventListener("click", function () { go(-1); });
    next.addEventListener("click", function () { go(1); });
    track.addEventListener("scroll", update, { passive: true });
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); go(1); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); go(-1); }
    });
    window.addEventListener("resize", update);
    update();
  }

  /* ---------- Avis courts sous la galerie : « Plus d'avis » = d'autres avis écrits, sans photo ---------- */
  function initQuotes(all) {
    var box = $(".pdp-quotes");
    var btn = box && $("[data-quotes-more]", box);
    if (!box || !btn) return;
    var shown = {};
    $$(".pdp-quote figcaption", box).forEach(function (f) { shown[f.textContent] = true; });
    var rest = all.filter(function (r) { return !(r.photos && r.photos.length) && !shown[r.nom] && r.texte.length > 24; });
    function more() {
      rest.splice(0, 3).forEach(function (r) {
        var fig = doc.createElement("figure");
        fig.className = "pdp-quote";
        fig.innerHTML = '<p class="cg-stars"></p><p class="pdp-quote__title"></p><blockquote></blockquote><figcaption></figcaption>';
        var st = fig.querySelector(".cg-stars");
        st.textContent = "★★★★★".slice(0, r.note);
        st.setAttribute("aria-label", r.note + " étoiles sur 5");
        var tt = fig.querySelector(".pdp-quote__title");
        tt.textContent = r.titre || "";
        tt.hidden = !r.titre;
        fig.querySelector("blockquote").textContent = r.texte;
        fig.querySelector("figcaption").textContent = r.nom;
        box.insertBefore(fig, btn);
      });
      btn.hidden = rest.length === 0;
    }
    btn.addEventListener("click", more);
    btn.hidden = rest.length === 0;
  }

  /* ---------- Avis : tri, filtre, « Voir plus », « Écrire un avis » ---------- */
  function initReviews() {
    var root = $("#avis");
    if (!root) return;
    var reviews = [{"nom":"Chloé T.","note":5,"texte":"Je ne pensais pas qu'un simple morceau de plastique transparent changerait quoi que ce soit. Et pourtant si. Je ne me douche plus jamais sans. 🚿","d":"2026-01-13","photos":[{"src":window.cgAsset("assets/images/avis-04-1.webp"),"w":572,"h":1024}]},{"nom":"Léa K.","note":5,"texte":"Je pensais que c'était trop beau pour être vrai et, pour le prix, je n'en attendais pas grand-chose. Il épouse bien mon visage, je vois à travers, et mes cils avaient le même aspect après qu'avant. Un conseil : appuyez fermement sur la bande, sur une peau sèche. Je le rachèterai.","d":"2026-03-24","photos":[{"src":window.cgAsset("assets/images/avis-21-1.webp"),"w":572,"h":1024}]},{"nom":"Pauline K.","note":4,"texte":"L'article est de très bonne qualité, c'est la deuxième fois que je l'achète, il est arrivé très vite, vous pouvez acheter sans crainte, il tient ses promesses. Il m'a beaucoup plu !","d":"2026-04-10","photos":[{"src":window.cgAsset("assets/images/avis-39-1.webp"),"w":572,"h":1024}]},{"nom":"Cécile B.","note":5,"texte":"Je stressais à chaque douche. Maintenant, je le mets et je continue ma journée. Mes cils étaient protégés et je n'ai pas eu besoin de me dépêcher pour une retouche. J'aurais aimé l'acheter plus tôt. 💖","d":"2026-03-05","photos":[{"src":window.cgAsset("assets/images/avis-40-1.webp"),"w":572,"h":1024}]},{"nom":"Alexandra S.","note":5,"texte":"Je serai honnête, j'étais sceptique. J'ai des extensions de cils et j'avais essayé de me couvrir les yeux avec la main, ce qui n'a jamais marché. Celui-ci a gardé l'eau et le shampoing loin de mes cils pendant que je me lavais les cheveux. Maintenant, je ne peux plus imaginer ma journée sans.","d":"2026-05-09","photos":[{"src":window.cgAsset("assets/images/avis-60-1.webp"),"w":572,"h":1024}]},{"nom":"Béatrice B.","note":5,"texte":"Ils sont arrivés en bon état.","d":"2026-09-14","photos":[{"src":window.cgAsset("assets/images/avis-00-1.webp"),"w":282,"h":500}]},{"nom":"Gabrielle G.","note":5,"texte":"J'espère que ça marchera pour moi.","d":"2026-04-17","photos":[{"src":window.cgAsset("assets/images/avis-02-1.webp"),"w":800,"h":1067},{"src":window.cgAsset("assets/images/avis-02-2.webp"),"w":800,"h":1067},{"src":window.cgAsset("assets/images/avis-02-3.webp"),"w":800,"h":1067}]},{"nom":"Mathilde H.","note":5,"texte":"Je compte le racheter ! Bien.","d":"2026-08-21","photos":[{"src":window.cgAsset("assets/images/avis-18-1.webp"),"w":800,"h":1067}]},{"nom":"Margot K.","note":5,"texte":"Je l'ai eu à bon prix. Ce serait bien de l'utiliser pour une permanente ou une coloration.","d":"2026-07-24","photos":[{"src":window.cgAsset("assets/images/avis-19-1.webp"),"w":540,"h":960}]},{"nom":"Clara K.","note":5,"texte":"👍🏻👍🏻👍🏻👍🏻👍🏻👍🏻👍🏻👍🏻👍🏻👍🏻","d":"2026-04-07","photos":[{"src":window.cgAsset("assets/images/avis-20-1.webp"),"w":504,"h":1080}]},{"nom":"Thaïs S.","note":5,"texte":"Le produit correspond à la description : 100 pièces. Très bons écrans. Livré rapidement par Nova Poshta. Je le recommande.","d":"2026-07-07","photos":[{"src":window.cgAsset("assets/images/avis-01-1.webp"),"w":738,"h":421},{"src":window.cgAsset("assets/images/avis-38-2.webp"),"w":705,"h":422}]},{"nom":"Michèle D.","note":5,"texte":"Il a l'air bien.","d":"2026-03-31","photos":[{"src":window.cgAsset("assets/images/avis-03-1.webp"),"w":800,"h":1067},{"src":window.cgAsset("assets/images/avis-61-2.webp"),"w":800,"h":1067}]},{"nom":"Emma F.","note":5,"d":"2025-12-05","photos":[{"src":window.cgAsset("assets/images/avis-63-1.webp"),"w":800,"h":1067}]},{"nom":"Lauren P.","note":5,"titre":"Facile à utiliser","texte":"Je pensais que ce serait difficile à positionner, mais c'est en réalité très simple. Je le maintiens en place sous la douche et je peux me laver le visage et les cheveux avec plus de confiance. C'est devenu un geste pratique de ma routine beauté"},{"nom":"Laura C.","note":5,"titre":"Léger et pratique","texte":"Je craignais qu'il soit inconfortable ou gênant, mais il est léger et facile à manier. Je peux me concentrer sur ma douche sans essayer de protéger mes cils avec les mains. Une idée toute simple qui change vraiment les choses"},{"nom":"Manon W.","note":5,"texte":"Parfait, je le recommande, livré à La Réunion 🇷🇪","d":"2026-03-27"},{"nom":"Romane B.","note":5,"texte":"Arrivé rapidement, tout est satisfaisant, je recommande le vendeur et le produit.","d":"2026-03-09"},{"nom":"Émilie H.","note":5,"texte":"C'est mon deuxième achat, donc ce qui se remarque surtout, c'est la force de l'adhésif. J'ai encore celui que j'utilisais avant, donc je parle du nouveau que j'ai acheté. Il faudra un peu de temps pour un avis vraiment réaliste.","d":"2026-01-17"},{"nom":"Corinne G.","note":5,"texte":"Arrivé à temps, l'adhésif tient bien, je peux en commander d'autres.","d":"2025-12-07"},{"nom":"Hélène S.","note":5,"texte":"C'est un produit que j'utilise tout le temps.","d":"2025-11-30"},{"nom":"Juliette R.","note":5,"texte":"Bonne qualité","d":"2025-11-21"},{"nom":"Aurélie B.","note":5,"texte":"Parfait pour éviter que des sourcils ou des cils fraîchement faits ne soient mouillés.","d":"2026-10-07"},{"nom":"Maëlle M.","note":5,"texte":"Reçu à temps, bonne qualité. Ils étaient en bon état, sans plis.","d":"2026-08-02"},{"nom":"Charlotte S.","note":5,"texte":"Je l'aime beaucoup, il est génial.","d":"2026-01-18"},{"nom":"Élodie E.","note":5,"texte":"Il est identique à la photo, je suis satisfaite. Je le recommande, et la livraison est rapide aussi.","d":"2026-01-03"},{"nom":"Marion J.","note":5,"texte":"Excellent pour pouvoir se doucher après une opération ophtalmologique, afin que ni l'eau ni le savon n'entrent dans les yeux.","d":"2025-12-16"},{"nom":"Lucie R.","note":5,"texte":"Satisfaite pour la coloration ou les soins capillaires.","d":"2025-12-05"},{"nom":"Jeanne O.","note":5,"texte":"C'est utile haha, il y en a beaucoup, c'est bien.","d":"2025-11-20"},{"nom":"Rose L.","note":5,"texte":"J'ai fait un bon achat à petit prix.","d":"2026-06-12"},{"nom":"Amandine T.","note":5,"texte":"Tout est parfait.","d":"2026-02-27"},{"nom":"Brigitte F.","note":5,"texte":"Excellent","d":"2026-02-07"},{"nom":"Bénédicte K.","note":5,"texte":"Ok~ Il y en a tellement, faut-il tout utiliser ? Haha.","d":"2026-01-26"},{"nom":"Murielle B.","note":5,"texte":"Super produit","d":"2025-12-08"},{"nom":"Anaïs B.","note":5,"texte":"Super","d":"2025-12-06"},{"nom":"Éléonore B.","note":5,"texte":"Produit de bonne qualité","d":"2025-11-14"},{"nom":"Géraldine R.","note":5,"texte":"Je l'ai bien reçu. Je l'utiliserai bien.","d":"2025-11-02"},{"nom":"Marine A.","note":5,"texte":"La livraison a été bien plus rapide que prévu. Très bien emballé, tout est conforme. Je ne sais pas encore comment ils se comporteront à l'usage, mais ils ont l'air super.","d":"2026-04-23"},{"nom":"Rosalie Y.","note":3,"texte":"Je suis bluffée. Gros bisous à toute l'équipe !","d":"2026-04-17"},{"nom":"Mylène J.","note":5,"texte":"Oui, c'est un bon rapport qualité-prix. J'en achèterai de nouveau la prochaine fois. Vendeur, s'il vous plaît, vendez-en beaucoup.","d":"2026-03-24"},{"nom":"Yasmine G.","note":5,"texte":"Il a l'air de faire l'affaire.","d":"2026-02-25"},{"nom":"Rachel B.","note":4,"texte":"Bien","d":"2026-01-17"},{"nom":"Lise M.","note":5,"texte":"100 %","d":"2025-11-09"}].map(function (r) { r.date = r.d ? Date.parse(r.d) : 0; return r; }); /* avis des clientes de l'ancienne marque (même produit) */
    initQuotes(reviews);
    var PAGE = 9, shown = PAGE;
    var list = $("[data-rv-list]", root), empty = $("[data-rv-empty]", root), more = $("[data-rv-more]", root);
    var sort = $("[data-rv-sort]", root), filter = $("[data-rv-filter]", root);
    var avg = $("[data-rv-avg]", root), count = $("[data-rv-count]", root);
    var form = $("[data-rv-form]", root), write = $("[data-rv-write]", root), thanks = $("[data-rv-thanks]", root);
    var error = $("[data-rv-error]", root);


    /* photo agrandie, avec les autres photos du même avis */
    var zoom = null, zoomList = [], zoomAt = 0, zoomFrom = null;
    function openZoom(photos, nom) {
      zoomList = photos; zoomAt = 0; zoomFrom = doc.activeElement;
      if (!zoom) {
        zoom = doc.createElement("div");
        zoom.className = "rv-zoom"; zoom.setAttribute("role", "dialog"); zoom.setAttribute("aria-modal", "true"); zoom.hidden = true;
        zoom.innerHTML = '<button class="rv-zoom__btn rv-zoom__close" type="button" aria-label="Fermer">&times;</button><button class="rv-zoom__btn rv-zoom__prev" type="button" aria-label="Photo précédente">&#8249;</button><img class="rv-zoom__img" alt=""><button class="rv-zoom__btn rv-zoom__next" type="button" aria-label="Photo suivante">&#8250;</button>';
        doc.body.appendChild(zoom);
        zoom.addEventListener("click", function (e) {
          if (e.target === zoom || e.target.classList.contains("rv-zoom__close")) closeZoom();
          else if (e.target.classList.contains("rv-zoom__prev")) show(-1);
          else if (e.target.classList.contains("rv-zoom__next")) show(1);
        });
        doc.addEventListener("keydown", function (e) {
          if (zoom.hidden) return;
          if (e.key === "Escape") closeZoom(); else if (e.key === "ArrowLeft") show(-1); else if (e.key === "ArrowRight") show(1);
        });
      }
      zoom.setAttribute("aria-label", "Photo de " + nom);
      zoom.hidden = false; doc.documentElement.classList.add("rv-zoom-open");
      show(0);
      zoom.querySelector(".rv-zoom__close").focus();
    }
    function show(step) {
      zoomAt = (zoomAt + step + zoomList.length) % zoomList.length;
      var img = zoom.querySelector(".rv-zoom__img");
      img.src = zoomList[zoomAt].src; img.alt = "Photo " + (zoomAt + 1) + " sur " + zoomList.length;
      zoom.classList.toggle("is-single", zoomList.length < 2);
    }
    function closeZoom() { zoom.hidden = true; doc.documentElement.classList.remove("rv-zoom-open"); if (zoomFrom && zoomFrom.focus) zoomFrom.focus(); }

    function stars(n) { return "★★★★★".slice(0, n) + "☆☆☆☆☆".slice(0, 5 - n); }
    function render() {
      var min = parseInt(filter.value, 10) || 0;
      var rows = reviews.filter(function (r) { return !min || r.note === min; });
      if (sort.value === "best") rows.sort(function (a, b) { return b.note - a.note; });
      else if (sort.value === "worst") rows.sort(function (a, b) { return a.note - b.note; });
      else rows.sort(function (a, b) { return b.date - a.date; });
      list.innerHTML = "";
      rows.slice(0, shown).forEach(function (r) {
        var li = doc.createElement("li");
        li.className = "rv__item";
        li.innerHTML = '<div class="rv__item-body"><div class="rv__item-head"><strong></strong><span class="cg-stars"></span></div><p class="rv__item-date"></p><p class="rv__item-title"></p><p class="rv__item-text"></p></div>';
        li.querySelector("strong").textContent = r.nom;
        li.querySelector(".cg-stars").textContent = stars(r.note);
        li.querySelector(".rv__item-date").textContent = r.date ? new Date(r.date).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" }) : "";
        li.querySelector(".rv__item-title").textContent = r.titre || "";
        li.querySelector(".rv__item-text").textContent = r.texte;
        if (r.photos && r.photos.length) {
          var ph = r.photos[0], btn = doc.createElement("button"), im = doc.createElement("img");
          btn.type = "button"; btn.className = "rv__photo"; btn.setAttribute("aria-label", "Agrandir la photo de " + r.nom);
          im.src = ph.src; im.alt = "Photo de " + r.nom; im.width = ph.w; im.height = ph.h; im.loading = "lazy";
          btn.appendChild(im);
          if (r.photos.length > 1) { var c = doc.createElement("span"); c.className = "rv__photo-count"; c.textContent = String(r.photos.length); btn.appendChild(c); }
          btn.addEventListener("click", function () { openZoom(r.photos, r.nom); });
          li.insertBefore(btn, li.firstChild);
        }
        list.appendChild(li);
      });
      empty.hidden = reviews.length > 0;
      more.hidden = rows.length <= shown;
      var has = reviews.length > 0;
      sort.disabled = filter.disabled = !has;
      if (has) {
        var mean = reviews.reduce(function (s, r) { return s + r.note; }, 0) / reviews.length;
        avg.textContent = mean.toFixed(1).replace(".", ",");
        count.textContent = reviews.length + (reviews.length > 1 ? " avis" : " avis");
      } else {
        avg.textContent = "–";
        count.textContent = "Aucun avis pour le moment";
      }
    }
    sort.addEventListener("change", function () { shown = PAGE; render(); });
    filter.addEventListener("change", function () { shown = PAGE; render(); });
    more.addEventListener("click", function () { shown += PAGE; render(); });

    function openForm(state) {
      form.hidden = !state;
      write.setAttribute("aria-expanded", String(state));
      thanks.hidden = true;
      if (state) { var f = $("input[name=prenom]", form); if (f) f.focus(); }
    }
    write.addEventListener("click", function () { openForm(form.hidden); });
    $("[data-rv-cancel]", root).addEventListener("click", function () { openForm(false); write.focus(); });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var note = form.querySelector("input[name=note]:checked");
      var prenom = form.elements.prenom.value.trim();
      var mail = form.elements.email.value.trim();
      var texte = form.elements.avis.value.trim();
      var msg = "";
      if (!note) msg = "Merci de choisir une note de 1 à 5 étoiles.";
      else if (!prenom) msg = "Merci d’indiquer votre prénom.";
      else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) msg = "Merci de saisir une adresse e-mail valide.";
      else if (!texte) msg = "Merci d’écrire quelques mots sur votre expérience.";
      error.hidden = !msg;
      error.textContent = msg;
      if (msg) return;
      form.reset();
      openForm(false);
      thanks.hidden = false;
    });
    render();
  }

  /* ---------- Animations GSAP ---------- */
  var RED = "rgb(217, 87, 59)", GRAY = "rgb(191, 195, 185)";
  var ON = { backgroundColor: "rgb(233, 247, 236)", borderTopColor: "rgb(17, 17, 17)", borderRightColor: "rgb(17, 17, 17)", borderBottomColor: "rgb(17, 17, 17)", borderLeftColor: "rgb(17, 17, 17)" };
  var OFF = { backgroundColor: "rgb(255, 255, 255)", borderTopColor: "rgb(17, 17, 17)", borderRightColor: "rgb(17, 17, 17)", borderBottomColor: "rgb(17, 17, 17)", borderLeftColor: "rgb(17, 17, 17)" };

  function initSol(reduce) {
    var viz = $("[data-sol]");
    if (!viz || !window.gsap) return;
    var cssEase = CustomEase.create("cgCssEase", "0.25,0.1,0.25,1");       /* ease */
    var draw = CustomEase.create("cgDraw", "0.45,0,0.2,1");                 /* A7 / A18 */
    var btnSans = $('[data-state="sans"]', viz), btnAvec = $('[data-state="avec"]', viz);
    var lineSans = $(".cg-pdp-sol__line--sans", viz), lineAvec = $(".cg-pdp-sol__line--avec", viz);
    var areaSans = $(".cg-pdp-sol__area--sans", viz), areaAvec = $(".cg-pdp-sol__area--avec", viz);
    var marks = $$(".cg-pdp-sol__mark", viz), bracket = $(".cg-pdp-sol__bracket", viz);
    var early = [$(".cg-pdp-sol__chew", viz)].concat(marks.filter(function (m) { return !m.classList.contains("cg-pdp-sol__late"); }));
    var late = marks.filter(function (m) { return m.classList.contains("cg-pdp-sol__late"); }).concat([bracket]);
    var tl = null, state = "avec";

    function setButtons(s) {
      state = s;
      btnSans.classList.toggle("is-active", s === "sans"); btnSans.setAttribute("aria-pressed", String(s === "sans"));
      btnAvec.classList.toggle("is-active", s === "avec"); btnAvec.setAttribute("aria-pressed", String(s === "avec"));
    }
    function to(t, v, dur, ease) {
      return gsap.to(t, Object.assign({ duration: reduce ? 0 : dur, ease: ease || cssEase, overwrite: "auto" }, v));
    }

    /* Bascule manuelle (boutons) */
    function show(s) {
      if (tl) { tl.kill(); tl = null; }
      setButtons(s);
      to(early.concat(late), { opacity: 1 }, 0.4);
      if (s === "avec") {
        to(btnAvec, ON, 0.2); to(btnSans, OFF, 0.2);
        lineSans.classList.add("is-dashed");
        to(lineSans, { stroke: GRAY, strokeWidth: 3, strokeDashoffset: 0 }, 0.3);
        to(areaSans, { opacity: 0 }, 0.5);
        to(lineAvec, { strokeDashoffset: 0 }, 1.4, draw);
        to(areaAvec, { opacity: 0.28, delay: reduce ? 0 : 0.6 }, 0.5);
      } else {
        to(btnSans, ON, 0.2); to(btnAvec, OFF, 0.2);
        lineSans.classList.remove("is-dashed");
        to(lineSans, { stroke: RED, strokeWidth: 4.5, strokeDashoffset: 0 }, 0.3);
        to(areaSans, { opacity: 0.28, delay: reduce ? 0 : 0.2 }, 0.5);
        to(lineAvec, { strokeDashoffset: 1 }, 0.6, draw);
        to(areaAvec, { opacity: 0 }, 0.3);
      }
    }
    btnSans.addEventListener("click", function () { if (state !== "sans" || tl) show("sans"); });
    btnAvec.addEventListener("click", function () { if (state !== "avec" || tl) show("avec"); });
    if (reduce) return;

    /* A14–A20 : état de départ, posé au chargement (l'état final est celui du CSS) */
    setButtons("sans");
    gsap.to(btnAvec, Object.assign({ duration: 0.2, ease: cssEase }, OFF));                         // A14, A15
    gsap.to(early.concat(late), { opacity: 0, duration: 0.4, ease: cssEase });                       // A16
    gsap.to(areaAvec, { opacity: 0, duration: 0.5, ease: cssEase });                                // A17
    gsap.set(areaSans, { opacity: 0 });
    gsap.to([lineSans, lineAvec], { strokeDashoffset: 1, duration: 1.4, ease: draw });              // A18
    gsap.to(lineSans, { stroke: RED, duration: 0.3, ease: cssEase });                                // A19
    gsap.to(lineSans, { strokeWidth: 4.5, duration: 0.3, ease: cssEase });                           // A20
    lineSans.classList.remove("is-dashed");

    /* A1–A10 : lecture à l'entrée à l'écran */
    ScrollTrigger.create({
      trigger: viz, start: "top 75%", once: true,
      onEnter: function () {
        tl = gsap.timeline({ onComplete: function () { tl = null; } });
        tl.to(early, { opacity: 1, duration: 0.4, ease: cssEase }, 0)                                // A5
          .to(late, { opacity: 1, duration: 0.4, ease: cssEase }, 0.7)                               // A5 (éléments « late »)
          .to(lineSans, { strokeDashoffset: 0, duration: 1.4, ease: draw }, 0)                        // A7
          .to(areaSans, { opacity: 0.28, duration: 0.5, ease: cssEase }, 0.5)                         // A6
          .add(function () { setButtons("avec"); lineSans.classList.add("is-dashed"); }, 1.6)
          .to(btnAvec, Object.assign({ duration: 0.2, ease: cssEase }, ON), 1.6)                      // A1, A2
          .to(btnSans, Object.assign({ duration: 0.2, ease: cssEase }, OFF), 1.6)                     // A3, A4
          .to(areaSans, { opacity: 0, duration: 0.5, ease: cssEase }, 1.6)                            // A8
          .to(lineSans, { stroke: GRAY, duration: 0.3, ease: cssEase }, 1.6)                          // A9
          .to(lineSans, { strokeWidth: 3, duration: 0.3, ease: cssEase }, 1.6)                        // A10
          .to(lineAvec, { strokeDashoffset: 0, duration: 1.4, ease: draw }, 1.7)                      // A7 (courbe « avec »)
          .to(areaAvec, { opacity: 0.28, duration: 0.5, ease: cssEase }, 2.3);                        // A6 (aire « avec », délai 0,6 s)
      }
    });
  }

  function initTimeline(reduce) {
    var line = $("[data-timeline]");
    if (!line || !window.gsap) return;
    var cssEase = CustomEase.create("cgCssEase", "0.25,0.1,0.25,1");
    var steps = $$(".cg-pdp-att__step", line);
    if (reduce) { gsap.set(line, { "--cg-progress": 1 }); return; }

    /* A13 : remplissage du rail, lié au défilement */
    gsap.fromTo(line, { "--cg-progress": 0 }, {
      "--cg-progress": 1, ease: "none",
      scrollTrigger: { trigger: line, start: "top bottom", end: "bottom bottom", scrub: true }
    });

    steps.forEach(function (step) {
      var marks = $$(".cg-pdp-att__dot, .cg-pdp-att__when", step);
      step.classList.remove("is-reached");
      gsap.to(step, { opacity: 0.35, duration: 0.4, ease: cssEase });                                // A21
      gsap.to(marks, { backgroundColor: "rgb(185, 190, 177)", duration: 0.3, ease: cssEase });         // A22
      ScrollTrigger.create({
        trigger: step, start: "top 60%", once: true,
        onEnter: function () {
          step.classList.add("is-reached");
          gsap.to(step, { opacity: 1, duration: 0.4, ease: cssEase, overwrite: "auto" });             // A11
          gsap.to(marks, { backgroundColor: "rgb(22, 39, 31)", duration: 0.3, ease: cssEase, overwrite: "auto" }); // A12
        }
      });
    });
  }

  function initMotion() {
    if (!CG.ready) { return; }
    CG.ready(function (ctx) {
      var reduce = !!ctx.conditions.reduce;
      initSol(reduce);
      initTimeline(reduce);
      ScrollTrigger.refresh();
    });
  }

  function init() {
    initGallery();
    initBuy();
    initCarousel();
    initReviews();
    initMotion();
  }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", init); else init();
})();
